export const PRINCIPALMENU = [
  {
    keyApp: "configuration",
    navigation: "configuration",
    title: "Configuración",
    subtitle: "Usuarios, roles",
    image: "fal fa-cog",
    hasChildren: true,
    showInMenu: true,
  },
  {
    keyApp: "instalationsMenu",
    navigation: "instalations",
    title: "Instalación",
    subtitle: "Instalaciones y equipos",
    image: "fal fa-building",
    hasChildren: true,
    showInMenu: false,
  },
  {
    keyApp: "incidencesMenu",
    navigation: "incidences",
    title: "Incidencias",
    subtitle: "Tus incidencias y partes de trabajo",
    image: "fal fa-exclamation-triangle",
    hasChildren: true,
    showInMenu: false,
  },
  {
    keyApp: "shopCarts",
    navigation: "shopCarts",
    title: "Compras",
    subtitle: "Carritos y Comprar",
    image: "fal fa-shopping-cart",
    hasChildren: true,
    showInMenu: false,
  },
  {
    keyApp: "procurement",
    navigation: "procurement",
    title: "Pedidos",
    subtitle: "Pedidos internos, compras y albaranes",
    image: "fal fa-file-invoice",
    hasChildren: true,
    showInMenu: false,
  },
  {
    keyApp: "satisfactions",
    navigation: "satisfactions",
    title: "Satisfacciones",
    subtitle: "Satisfacciones sobre las incidencias",
    image: "fal fa-smile",
    showInMenu: false,
  },
  {
    keyApp: "stadistics",
    navigation: "stadistics",
    title: "Estadísticas",
    subtitle: "Estadísticas sobre la aplicación",
    image: "fal fa-chart-line",
    showInMenu: true,
  },
  {
    keyApp: "projectsMenu",
    navigation: "projects",
    title: "Proyectos",
    subtitle: "Proyectos y diagrama de gantt",
    image: "fal fa-project-diagram",
    hasChildren: true,
    showInMenu: false,
  },
  {
    keyApp: "singUp",
    navigation: "singUp",
    title: "Fichar",
    subtitle: "Fichar entradas y salidas",
    image: "fal fa-fingerprint",
    showInMenu: true,
  },
  {
    keyApp: "singUpsMenu",
    navigation: "singUps",
    title: "Control de accesos",
    subtitle: "Ver todos los accesos",
    image: "fal fa-id-card",
    hasChildren: true,
    showInMenu: true,
  },
  {
    keyApp: "RRHH",
    navigation: "RRHH",
    title: "RRHH",
    subtitle: "Recursos humanos",
    image: "fal fa-users",
    hasChildren: true,
    showInMenu: true,
  },
  {
    keyApp: "dosification",
    navigation: "dosification",
    title: "Dosificación",
    subtitle: "Productos y dosificaciones",
    image: "fal fa-flask",
    showInMenu: false,
    hasChildren: false,
  },
  {
    keyApp: "invoicesDeliveryNotes",
    navigation: "allInvoicesDeliveryNotes",
    title: "Facturas y albaranes",
    subtitle: "Descargar las facturas y albaranes de este año",
    image: "fal fa-file-invoice-dollar",
    hasChildren: true,
    showInMenu: false,
  },
  {
    keyApp: "episMenu",
    navigation: "epis",
    title: "EPIS y materias primas",
    subtitle: "Control de EPIS y materias primas",
    image: "fal fa-hard-hat",
    showInMenu: false,
    hasChildren: false,
  },
  {
    keyApp: "repartiments",
    navigation: "repartiments",
    title: "Repartos",
    subtitle: "Ver todos los albaranes de hoy",
    image: "fal fa-truck",
    showInMenu: false,
  },
  {
    keyApp: "suggestion",
    navigation: "suggestion",
    title: "Sugerencias",
    subtitle: "Introduce errores o sugerencias",
    image: "fal fa-mailbox",
    showInMenu: false,
  },
  {
    keyApp: "expenses",
    navigation: "expenses",
    title: "Gastos",
    subtitle: "Introduce gastos",
    image: "fal fa-receipt",
    showInMenu: false,
  },
  {
    keyApp: "opcua",
    navigation: "opcua",
    title: "OPCUA",
    subtitle: "Introduce la configuración del OPCUA",
    image: "fal fa-network-wired",
    showInMenu: false,
  },
];

export const CONFIGURATIONMENU = [
  {
    keyApp: "users",
    navigation: "configuration/users",
    title: "Usuarios",
    subtitle: "Todos los usuarios",
    image: "fal fa-user",
    showInMenu: true,
  },
  {
    keyApp: "tags",
    navigation: "configuration/tags",
    title: "Tags",
    subtitle: "Ver todas las tags de gastos",
    image: "fal fa-tags",
    showInMenu: false,
  },
  {
    keyApp: "reasons",
    navigation: "configuration/reasons",
    title: "Motivos",
    subtitle: "Ver todos los motivos de horas extras",
    image: "fal fa-lightbulb",
    showInMenu: false,
  },
  {
    keyApp: "roles",
    navigation: "configuration/roles",
    title: "Roles",
    subtitle: "Ver todos los roles",
    image: "fal fa-user-shield",
    showInMenu: true,
  },
];

export const PROJECTSMENU = [
  {
    keyApp: "projects",
    navigation: "projects/projects",
    title: "Proyectos",
    subtitle: "Todos los proyectos",
    image: "fal fa-project-diagram",
    showInMenu: true,
  },
  {
    keyApp: "ganttDiagram",
    navigation: "projects/ganttDiagram",
    title: "Diagrama de gantt",
    subtitle: "Vista del diagrama de gantt",
    image: "fal fa-tasks",
    showInMenu: true,
  },
];

export const SHOPMENU = [
  {
    keyApp: "shopCarts",
    navigation: "shopCarts/carts",
    title: "Carritos",
    subtitle: "Todos los carritos",
    image: "fal fa-shopping-cart",
    showInMenu: true,
  },
  {
    keyApp: "buy",
    navigation: "shopCarts/buy",
    title: "Comprar",
    subtitle: "Realiza compras",
    image: "fal fa-shopping-basket",
    showInMenu: true,
  },
  {
    keyApp: "securitySheets",
    navigation: "shopCarts/security",
    title: "Fichas técnicas",
    subtitle: "Ver todas las fichas técnicas descargadas",
    image: "fal fa-shield-alt",
    showInMenu: true,
  },
];

export const PROCUREMENTMENU = [
  {
    keyApp: "internalOrders",
    navigation: "procurement/internalOrders",
    title: "Pedidos internos",
    subtitle: "Solicitudes internas de compra",
    image: "fal fa-clipboard-list",
    showInMenu: false,
  },
  {
    keyApp: "purchaseOrders",
    navigation: "procurement/purchaseOrders",
    title: "Pedidos de compras",
    subtitle: "Generar y seguir pedidos de compra",
    image: "fal fa-shopping-bag",
    showInMenu: true,
  },
  {
    keyApp: "deliveryNoteDocuments",
    navigation: "procurement/deliveryNotes",
    title: "Albaranes",
    subtitle: "Generar, visualizar y descargar albaranes",
    image: "fal fa-file-alt",
    showInMenu: true,
  },
];

export const INSTALATIONMENU = [
  {
    keyApp: "instalations",
    navigation: "instalations/instalation",
    title: "Instalaciones",
    subtitle: "Tus instalaciones",
    image: "fal fa-building",
    showInMenu: true,
  },
  {
    keyApp: "equipments",
    navigation: "instalations/equipment",
    title: "Equipos",
    subtitle: "Tus equipos",
    image: "fal fa-server",
    showInMenu: true,
  },
];

export const INCIDENCESMENU = [
  {
    keyApp: "incidences",
    navigation: "incidences/incidences",
    title: "Incidencias",
    subtitle: "Tus incidencias",
    image: "fal fa-exclamation-triangle",
    showInMenu: true,
  },
  {
    keyApp: "workOrders",
    navigation: "incidences/workOrders",
    title: "Partes de trabajo",
    subtitle: "Tus partes de trabajo",
    image: "fal fa-file-signature",
    showInMenu: true,
  },
];

export const INVOICESMENU = [
  {
    keyApp: "invoices",
    navigation: "allInvoicesDeliveryNotes/invoices",
    title: "Facturas",
    subtitle: "Tus facturas",
    image: "fal fa-file-invoice",
    showInMenu: true,
  },
  {
    keyApp: "deliveryNotes",
    navigation: "allInvoicesDeliveryNotes/deliveryNotes",
    title: "Albaranes",
    subtitle: "Tus albaranes",
    image: "fal fa-file-alt",
    showInMenu: true,
  },
];

export const SINGUPS = [
  {
    keyApp: "singUps",
    navigation: "singUps/singUpsList",
    title: "Control de accesos",
    subtitle: "Ver todos los accesos",
    image: "fal fa-id-card",
    showInMenu: true,
  },
  {
    keyApp: "timepunchcomercials",
    navigation: "singUps/timepunchcomercialsList",
    title: "Accesos comerciales",
    subtitle: "Ver todos los accesos comerciales",
    image: "fal fa-user-chart",
    showInMenu: true,
  },
  {
    keyApp: "timeRequests",
    navigation: "singUps/timeRequest",
    title: "Peticiones",
    subtitle: "Peticiones de cambio de fecha",
    image: "fal fa-calendar-alt",
    showInMenu: true,
  },
  {
    keyApp: "absences",
    navigation: "singUps/absences",
    title: "Ausencias",
    subtitle: "Ausencias",
    image: "fal fa-calendar-times",
    showInMenu: true,
  },
  {
    keyApp: "map",
    navigation: "singUps/map",
    title: "Mapa",
    subtitle: "Mapa con los fichajes",
    image: "fal fa-map-marked-alt",
    showInMenu: true,
  },
  {
    keyApp: "timepunchcomercials",
    navigation: "singUps/timepunchcomercialsMap",
    title: "Mapa comerciales",
    subtitle: "Mapa con fichajes comerciales",
    image: "fal fa-map-marker-alt",
    showInMenu: true,
  },
];

export const RRHH = [
  {
    keyApp: "mySingUp",
    navigation: "RRHH/mySingUp",
    title: "Mis accesos",
    subtitle: "Consultar accesos y solicitar cambios",
    image: "fal fa-calendar-check",
    delegateAccess: true,
    showInMenu: true,
  },
  {
    keyApp: "holidayRequests",
    navigation: "RRHH/holidayRequest",
    title: "Vacaciones",
    subtitle: "Peticiones de vacaciones y bajas",
    image: "fal fa-umbrella-beach",
    showInMenu: true,
  },
  // {
  //   keyApp: "workShifts",
  //   navigation: "RRHH/workShift",
  //   title: "Turnos",
  //   subtitle: "Turnos de trabajo",
  //   image: `url(${cambio})`,
  //   showInMenu: true,
  // },
  {
    keyApp: "leaves",
    navigation: "RRHH/leave",
    title: "Bajas",
    subtitle: "Bajas de trabajo",
    image: "fal fa-procedures",
    showInMenu: true,
  },
  {
    keyApp: "overtimes",
    navigation: "RRHH/overtimes",
    title: "Horas extra",
    subtitle: "Horas extra",
    image: "fal fa-stopwatch",
    showInMenu: true,
  },
];

export const DOSIFICATION = [
  {
    keyApp: "dosification",
    navigation: "dosification/dosification",
    title: "Dosificación",
    subtitle: "Productos y configuración",
    image: "fal fa-flask",
    showInMenu: false,
  },
  {
    keyApp: "dosificationProducts",
    navigation: "dosification/dosificationProducts",
    title: "Productos",
    subtitle: "Dosificaciones",
    image: "fal fa-industry",
    showInMenu: false,
  },
];

export const EPIS = [
  {
    keyApp: "epis",
    navigation: "epis/epis",
    title: "Control de EPIS",
    subtitle: "Control de EPIS",
    image: "fal fa-hard-hat",
    showInMenu: true,
  },
  {
    keyApp: "raws",
    navigation: "epis/raw",
    title: "Materias primas",
    subtitle: "Materias primas",
    image: "fal fa-boxes",
    showInMenu: true,
  },
];

export const BASICMENU = {
  configuration: CONFIGURATIONMENU,
  procurement: PROCUREMENTMENU,
  singUpsMenu: SINGUPS,
  RRHH,
}

export const ALLMENU = Array.prototype.concat(
  PRINCIPALMENU,
  CONFIGURATIONMENU,
  PROCUREMENTMENU,
  SINGUPS,
  RRHH,
);
